// src/components/registro/CampoUbicacionGPS.js
//
// Captura latitud/longitud con navigator.geolocation. Muestra el estado
// (pidiendo permiso, capturando, capturado, error).

import React, { useState } from 'react';
import { Box, Button, Typography, Alert, Chip } from '@mui/material';
import MyLocationIcon from '@mui/icons-material/MyLocation';

export default function CampoUbicacionGPS({ lat, lng, onChange, disabled }) {
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const capturar = () => {
    if (!navigator.geolocation) {
      setError('Este navegador no soporta ubicación GPS.');
      return;
    }
    setError('');
    setCargando(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setCargando(false);
        onChange({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      },
      (err) => {
        setCargando(false);
        setError(err.code === 1
          ? 'Diste permiso NO al navegador. Actívalo para usar tu ubicación.'
          : 'No se pudo obtener la ubicación.'
        );
      },
      { enableHighAccuracy: true, timeout: 15000 }
    );
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        Ubicación GPS (opcional, ayuda a que los vecinos te encuentren)
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Button
          variant="outlined"
          startIcon={<MyLocationIcon />}
          onClick={capturar}
          disabled={disabled || cargando}
        >
          {cargando ? 'Capturando…' : (lat && lng ? 'Actualizar ubicación' : 'Usar mi ubicación')}
        </Button>
        {lat && lng && (
          <Chip
            label={`${lat.toFixed(5)}, ${lng.toFixed(5)}`}
            color="success"
            variant="outlined"
            onDelete={() => onChange({ lat: null, lng: null })}
          />
        )}
      </Box>
      {error && <Alert severity="warning" sx={{ mt: 1 }}>{error}</Alert>}
    </Box>
  );
}
